import { useState } from 'react'
import { customerData } from '../utilities/CustomerData'
import { apiURL } from '../utilities/URLs'

export function WelcomeModal({ setShowWelcomeModal }) {
  const [step, setStep] = useState(1)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [creatingPassword, setCreatingPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*\d)[A-Za-z\d!@#$%^&*()_+={}\[\]|\\:;\"'<>,.?~`-]{6,}$/
    return passwordRegex.test(password)
  }

  const handleCreateCustomerPassword = async () => {
    if (!validatePassword(password)) {
      setErrorMessage('Password must be at least 6 characters long and contain at least 1 number.')
      return
    }

    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match.')
      return
    }

    const form = new FormData()
    form.append('customerPasswordInfo', JSON.stringify({ password }))

    try {
      setCreatingPassword(true)
      const createCustomerPasswordResponse = await fetch(`${apiURL}/api/createCustomerPassword`, {
        method: 'PUT',
        headers: {
          Authorization: customerData.accessToken,
        },
        body: form,
      })

      const createCustomerPasswordData = await createCustomerPasswordResponse.json()
      setCreatingPassword(false)
      if (createCustomerPasswordData.response.error)
        console.error(createCustomerPasswordData.response.error)
      else {
        localStorage.setItem('customerAccessToken', createCustomerPasswordData.response.accessToken)
        customerData.accessToken = createCustomerPasswordData.response.accessToken
        setStep(3)
      }
    } catch (error) {
      console.error('Error creating password:', error)
    }
  }

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <>
            <h1 className='text-3xl font-bold text-center mb-4 text-blue-600'>Welcome to Your Customer Portal!</h1>
            <p className='text-gray-600 text-center mb-6'>Keep up to date with your deal along the process of getting your refund, view Q&A, access tax documents, and more.</p>
            <button onClick={() => setStep(2)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white font-semibold py-3 rounded-lg mt-4 hover:shadow-lg ease-in-out w-full'>
              Next
            </button>
          </>
        )
      case 2:
        return (
          <>
            <h1 className='text-3xl font-bold text-center mb-4 text-blue-600'>Let's set a password so you can log in</h1>
            <div className='flex flex-col gap-4'>
              <input
                type='password'
                placeholder='Enter your password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className='border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400 w-full transition-all duration-300'
              />
              <input
                type='password'
                placeholder='Confirm your password'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className='border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400 w-full transition-all duration-300'
              />
              {errorMessage && (
                <p className='text-red-500 text-center animate-pulse'>{errorMessage}</p>
              )}
              <button onClick={handleCreateCustomerPassword} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white font-semibold py-3 rounded-lg mt-4 hover:shadow-lg ease-in-out w-full'>
                Next
              </button>
              {creatingPassword && (
                <div className='flex flex-row items-center justify-center gap-2'>
                  <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8 mt-4'></div>
                  <p>Creating Password...</p>
                </div>
              )}
            </div>
          </>
        )
      case 3:
        return (
          <>
            <h1 className='text-3xl font-bold text-center mb-4 text-blue-600'>All set!</h1>
            <p className='text-gray-600 text-center mb-6'>You have successfully created your password.</p>
            <button onClick={() => setShowWelcomeModal(false)} className='bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white font-semibold py-3 rounded-lg mt-4 hover:shadow-lg ease-in-out w-full'>
              Finish
            </button>
          </>
        )
      default:
        return null
    }
  }

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-20'>
      <div className='bg-white shadow-lg rounded-lg p-8 max-w-md w-full animate-fade-in'>
        <div className='mb-4 flex justify-center space-x-2'>
          <span className={`h-2 w-8 rounded-full ${step === 1 ? 'bg-blue-600' : 'bg-gray-300'}`}></span>
          <span className={`h-2 w-8 rounded-full ${step === 2 ? 'bg-blue-600' : 'bg-gray-300'}`}></span>
          <span className={`h-2 w-8 rounded-full ${step === 3 ? 'bg-blue-600' : 'bg-gray-300'}`}></span>
        </div>
        {renderStepContent()}
      </div>
    </div>
  )
}
